module.exports = __webpack_public_path__ + "img/24.a44bda87.jpg";